import { iStoreCaseConfiguration } from '@/Interfaces/storeCaseConfiguration';
import { colors } from '@/Constants/colors';
// https://www.safe.ru/products/tc-shkaf-instrumentalnyy-tc-1995-2-102400/?sphrase_id=2284101
export const tc_1995_2_102400: Omit<iStoreCaseConfiguration & { name: string }, 'itemsFromApi'> = {
    id: 'ad47e618-e770-4d25-949f-19617167c8e4',
    name: '102400',
    selectedCaseModel: 'TC-1995-2',
    selectedCasePresetId: '2fcc9494-9c04-4368-b25b-f4e68a684a5c',
    blenderName: 'tc_1995_2',
    colorFrame: colors[0].hex,
    colorFace: colors[1].hex,
    image: 'dist/src/img/presets/image_3.png',
    caseItems : [
        {
        id: '2399654d-044b-4032-b195-c8215b261b6c',
        prototypeId: 'tcsh_43x47',
        indexPositionY: 3,
        isLeft: false,
    }, {
        id: '11a144ae-5761-43d0-ac11-c18d5f0b9e49',
        prototypeId: 'tcsh_43x47',
        indexPositionY: 13,
        isLeft: false,
    }, {
        id: '986330fb-370a-4f2b-bc6f-84c870d06bad',
        prototypeId: 'tcsh_43x47',
        indexPositionY: 6,
        isLeft: true,
    }, {
        id: 'ff0aa37b-8263-4f39-8a91-b4d64ac7f1a8',
        prototypeId: 'tcsh_43x47',
        indexPositionY: 16,
        isLeft: true,
    }, {
        id: '68aeb340-5a83-47f1-a7ca-4aef4ed7d216',
        prototypeId: 'tcd_1800_2',
        isLeft: false,
    }, {
        id: '7e7d8e51-7081-43de-90f5-3761a8b9736c',
        prototypeId: 'tcsh_95x47',
        indexPositionY: 35,
        isLeft: false,
    }, {
        id: 'c02ce668-4085-4ee8-a4f5-5819bac24dfb',
        prototypeId: 'tcsh_95x47',
        indexPositionY: 45,
        isLeft: true,
    } ],
    //TODO drawerSeparators count=0
    drawerSeparators: [],
    expandedDrawersPrototypeId: [],
};
